<template>
  <div>
    <el-dialog :visible.sync="modalConfirmPublish" :show-close="false" :title="$t('socialPosts.create.planification.title')" :v-loading="loadingStatus">
      <p>{{ $t('socialPosts.create.planification.instruction') }}</p>
      <div v-if="facebookChecked" style="border: 1px;border-color: #1e4a56;margin: 15px;">
        <el-row>
          <el-col :lg="24"><h3>
            <img
                alt=""
                :src="require(`@/assets/facebook-logo-5-1.png`)"
                width="20"
                style="padding-bottom: 8px;margin-right:15px;"
            />Facebook</h3>
          </el-col>
        </el-row>
        <el-row v-if="!post.facebook.alreadyPublished">
          <el-col :lg="12">
            <el-date-picker
                size="mini"
                :picker-options="pickerOptions"
                ref="picker"
                type="datetime"
                format="dd/MM/yyyy HH:mm"
                :clearable="false"
                v-model="post.facebook.datePlanif"
                @change="updateDatePlanif()"
                :placeholder="$t('socialPosts.create.planification.selectDateTime')">
            </el-date-picker>
          </el-col>
          <el-col :lg="12">
            <el-checkbox v-model="post.facebook.publishNow" @change="updatePublishNow()">{{ $t('socialPosts.create.planification.publishNow') }}</el-checkbox>
          </el-col>
        </el-row>
        <el-row v-else>
          {{ $t('socialPosts.create.planification.alreadyPublishedFacebook') }}
        </el-row>
      </div>
      <div v-if="instagramChecked" style="border: 1px;border-color: #1e4a56;margin: 15px;">
        <el-row>
          <el-col :lg="24"><h3><img
              alt=""
              :src="require(`@/assets/2048px-Instagram_icon.png`)"
              width="20"
              style="padding-bottom: 8px;margin-right:15px;"
          />Instagram</h3></el-col>
        </el-row>
        <el-row v-if="!post.instagram.alreadyPublished">
          <el-col :lg="12">
            <el-date-picker
                size="mini"
                :picker-options="pickerOptions"
                ref="picker"
                type="datetime"
                format="dd/MM/yyyy HH:mm"
                :clearable="false"
                @change="updateDatePlanif()"
                v-model="post.instagram.datePlanif"
                :placeholder="$t('socialPosts.create.planification.selectDateTime')">
            </el-date-picker>
          </el-col>
          <el-col :lg="12">
            <el-checkbox v-model="post.instagram.publishNow" @change="updatePublishNow()">{{ $t('socialPosts.create.planification.publishNow') }}</el-checkbox>
          </el-col>
        </el-row>
        <el-row v-else>
          {{ $t('socialPosts.create.planification.alreadyPublishedInstagram') }}
        </el-row>
      </div>
      <div v-if="googleChecked" style="border: 1px;border-color: #1e4a56;margin: 15px;">
        <el-row>
          <el-col :lg="24"><h3><img
              alt=""
              :src="require(`@/assets/1200px-Google-My-Business_logo.svg.png`)"
              width="20"
              style="padding-bottom: 8px;margin-right:15px;"
          />Google</h3></el-col>
        </el-row>
        <el-row  v-if="!post.google.alreadyPublished">
          <el-col :lg="12">
            <el-date-picker
                size="mini"
                :picker-options="pickerOptions"
                ref="picker"
                type="datetime"
                format="dd/MM/yyyy HH:mm"
                @change="updateDatePlanif()"
                :clearable="false"
                v-model="post.google.datePlanif"
                :placeholder="$t('socialPosts.create.planification.selectDateTime')">
            </el-date-picker>
          </el-col>
          <el-col :lg="12">
            <el-checkbox v-model="post.google.publishNow" @change="updatePublishNow()">{{ $t('socialPosts.create.planification.publishNow') }}</el-checkbox>
          </el-col>
        </el-row>
        <el-row v-else>
          {{ $t('socialPosts.create.planification.alreadyPublishedGoogle') }}
        </el-row>
      </div>
      <div v-if="linkedInChecked" style="border: 1px;border-color: #1e4a56;margin: 15px;">
        <el-row>
          <el-col :lg="24"><h3><img
              alt=""
              :src="require(`@/assets/linkedin-logo.png`)"
              width="20"
              style="padding-bottom: 8px;margin-right:15px;"
          />LinkedIn</h3></el-col>
        </el-row>
        <el-row  v-if="!post.linkedin.alreadyPublished">
          <el-col :lg="12">
            <el-date-picker
                size="mini"
                :picker-options="pickerOptions"
                ref="picker"
                type="datetime"
                format="dd/MM/yyyy HH:mm"
                @change="updateDatePlanif()"
                :clearable="false"
                v-model="post.linkedin.datePlanif"
                :placeholder="$t('socialPosts.create.planification.selectDateTime')">
            </el-date-picker>
          </el-col>
          <el-col :lg="12">
            <el-checkbox v-model="post.linkedin.publishNow" @change="updatePublishNow()">{{ $t('socialPosts.create.planification.publishNow') }}</el-checkbox>
          </el-col>
        </el-row>
        <el-row v-else>
          {{ $t('socialPosts.create.planification.alreadyPublishedLinkedin') }}
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">

      <el-button type="primary" @click="validate" :disabled="disabled">
            <span>{{ $t('socialPosts.create.planification.apply') }}</span>
         </el-button>

      <el-button @click="closeModal">
            <span>{{
                $t('portals.list.close')
              }}</span>
         </el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'DialogPlanifPostEditorial',
  props: ['post'],
  data () {
    return {
      disabled: false
    }
  },
  computed: {
    ...mapState('socialPostsCreationPostEditorial', [
      'modalConfirmPublish',
      'facebookChecked',
      'instagramChecked',
      'googleChecked',
      'linkedInChecked',
      'loadingStatus']),
    ...mapGetters('socialPostsCreationPostEditorial',
      ['getModalConfirmPublish']
    ),
    modalConfirmPublish: {
      get () {
        return this.$store.state.socialPostsCreationPostEditorial.modalConfirmPublish
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/setModalConfirmPublish', value)
      }
    },
    pickerOptions () {
      return {
        disabledDate (time) {
          const date = new Date()
          const yesterday = date.setDate(date.getDate() - 1)
          return time.getTime() < yesterday
        }
      }
    }
  },
  methods: {
    closeModal () {
      this.$store.commit('socialPostsCreationPostEditorial/setModalConfirmPublish', false)
    },
    updateDatePlanif (value) {
      if (this.post.facebook.datePlanif) {
        this.post.facebook.publishNow = false
      }
      if (this.post.instagram.datePlanif) {
        this.post.instagram.publishNow = false
      }
      if (this.post.google.datePlanif) {
        this.post.google.publishNow = false
      }
      if (this.post.linkedin.datePlanif) {
        this.post.linkedin.publishNow = false
      }
    },
    updatePublishNow (value) {
      if (this.post.facebook.publishNow) {
        this.post.facebook.datePlanif = null
      }
      if (this.post.instagram.publishNow) {
        this.post.instagram.datePlanif = null
      }
      if (this.post.google.publishNow) {
        this.post.google.datePlanif = null
      }
      if (this.post.linkedin.publishNow) {
        this.post.linkedin.datePlanif = null
      }
    },
    validate () {
      const networks = ['facebook', 'instagram', 'google', 'linkedin']
      const filteredPlanificationValid = Object.keys(this.post)
        .filter(key => networks.includes(key))
        .reduce((obj, key) => {
          if (this.post[key].datePlanif || this.post[key].publishNow) {
            obj[key] = this.post[key].datePlanif || this.post[key].publishNow
          }
          return obj
        }, {})
      let countCheckedNetworks = 0
      if (this.facebookChecked) {
        countCheckedNetworks++
      }
      if (this.instagramChecked) {
        countCheckedNetworks++
      }
      if (this.googleChecked) {
        countCheckedNetworks++
      }
      if (this.linkedInChecked) {
        countCheckedNetworks++
      }
      if (Object.keys(filteredPlanificationValid).length === countCheckedNetworks) {
        this.disabled = true
        this.$store.dispatch('socialPostsCreationPostEditorial/handlePublish')
      }
    }
  },
  beforeMount () {
    this.disabled = false
    this.$store.commit('socialPostsCreationPostEditorial/setModalConfirmPublish', false)
  }
}
</script>

<style scoped>
.info-no-planification {
  color: #ffc107;
}
</style>
